import { render, staticRenderFns } from "./IntegrationHistory.vue?vue&type=template&id=3cfbb0ec"
import script from "./IntegrationHistory.vue?vue&type=script&lang=js"
export * from "./IntegrationHistory.vue?vue&type=script&lang=js"
import style0 from "./IntegrationHistory.vue?vue&type=style&index=0&id=3cfbb0ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports